<style>
.red-home-button {
  background-color: #e3342f !important; /* Laravel red */
  color: white !important;
  border: none;
}

.red-home-button i {
  margin-right: 6px;
}

/* Put this in your <style> section or global CSS */
.input-valid {
  border: 2px solid #28a745 !important; /* green */
}
.input-invalid {
  border: 2px solid #dc3545 !important; /* red */
}


/* Full-width container on mobile */
@media (max-width: 767px) {
  .edit_application.full-mobile-width {
    width: 100% !important;
    padding-left: 0 !important;
    padding-right: 0 !important;
    margin: 0 !important;
  }

  .edit_application select{
    width: 100% !important;
    font-size: 1rem; /* consistent text size */
    padding: 0.5rem !important;
    box-sizing: border-box;
  }

  /* Remove container padding on mobile */
  .edit_application.full-mobile-width .container {
    padding-left: 0 !important;
    padding-right: 0 !important;
    max-width: 100% !important;
  }

  .edit_application .upload-box p {
    margin-bottom: 0.5rem;
    font-size: 0.9rem;
  }

  .edit_application .upload-box small {
    font-size: 0.8rem;
  }
}

@media (min-width: 764px) and (max-width: 1024px) {
  /* Outer container */
  .edit_application {
    width: 100% !important;
    padding-left: 0 !important;
    padding-right: 0 !important;
    margin: 0 !important;
  }

  /* Inner Bootstrap container */
  .edit_application .container {
    max-width: 100% !important;
    padding-left: 0.5rem !important;
    padding-right: 0.5rem !important;
  }

  /* Make form column full width like col-md-12 */
  .edit_application .col-md-8 {
    width: 100% !important;
    flex: 0 0 100% !important;
    max-width: 100% !important;
  }

  /* Stack instructions below form */
  .edit_application .col-md-4 {
    width: 100% !important;
    flex: 0 0 100% !important;
    max-width: 100% !important;
    margin-top: 1rem;
  }

  .edit_application .upload-box p {
    margin-bottom: 0.5rem;
    font-size: 0.9rem;
  }

  .edit_application .upload-box small {
    font-size: 0.8rem;
  }
}

@media (max-width: 360px) {
  .edit_application {
    width: 100% !important;
    padding-left: 0.3rem !important;
    padding-right: 0.3rem !important;
    margin: 0 auto !important;
  }

  .edit_application .container {
    max-width: 100% !important;
    padding-left: 0.3rem !important;
    padding-right: 0.3rem !important;
  }

  .edit_application .upload-box p {
    margin-bottom: 0.5rem;
    font-size: 0.9rem;
    word-wrap: break-word; /* allow long words to break */
    word-break: break-word; /* break long sentences */
    white-space: normal;   /* force wrapping */
  }

  .edit_application .upload-box small {
    font-size: 0.8rem;
    word-wrap: break-word;
    word-break: break-word;
  }
}


</style>
<template>
  <div class="edit_application pb-2 full-mobile-width">
    <div class="container tabs-container">
      <div class="row">
        <div class="col-md-12 mt-lg-5 content">
          <div class="tab-content ">
            <!-- Upcoming Tab -->
            <div class="tab-pane fade show active" id="upcoming">
              <div class="container mt-4">
                <div class="d-flex flex-column flex-md-row justify-content-between align-items-start align-items-md-center">
                  <h5 class="text-danger mb-2 mb-md-0">Visa Medical Appointment for {{ this.savedFormData?.data?.title }}</h5>
                </div>

                <div class="row g-0">
                  <div class="col-12 col-md-8">
                    <!-- <div class="mt-lg-5 mt-3">
                      <div class="booking-alert">
                        <strong class="booking-number">Booking Number : {{ paymentData?.booking_no }}</strong>
                        <p class="booking-text mt-3">Complete all fields and upload documents to update your appointment.</p>
                      </div>
                    </div>

                    <div class="slot_section">
                      <h5 class="mt-lg-5 mt-4">Update your Documents</h5>
                      <p class="custom-text mt-3">Please Provide your personal and booking information.</p>
                    </div> -->

                    <form class="p-lg-5 p-3" @submit="handleSubmit">
                        <div v-for="(form, index) in forms" :key="form.id" class="mb-4" >
                          <div class="app-header" @click="toggleForm(form.id)" style="cursor:pointer; background:#f0f0f0; padding: 10px;">
                            <h5 class="mb-0 text-danger">Application {{ index + 1 }}</h5>
                            <div :id="'arrow-' + form.id" class="circle-arrow" style="float:right;">
                              <div :class="{ 'chevron-up': currentlyOpenForm === form.id, 'chevron-down': currentlyOpenForm !== form.id }"></div>
                            </div>
                          </div>

                          <div v-show="currentlyOpenForm === form.id" class="application-form">
                            <div class="row g-0 pe-3">
                              <div class="col-md-12 appointment-form">
                                <div class="p-lg-5 p-3">
                                  <div class="row">
                                    

                                    <!-- <div v-for="(element) in savedFormData.data.elements" :key="element.id" class="mb-3"> -->
                                      <div v-for="(element) in savedFormData.data.elements" :key="element.id" class="mb-3">
                                        <template v-if="!element.is_conditional || 
                                          (
                                            conditionalValues[element.conditional_details.conditional_name] &&
                                            conditionalValues[element.conditional_details.conditional_name].toUpperCase() === 
                                            element.conditional_details.conditional_value.toUpperCase()
                                          )"
                                        >
                                        <!-- Label (except radio) -->
                                        <label v-if="element.type !== 'radio'" :for="element.name" class="form-label mb-2">
                                          {{ element.label }}
                                          <small v-if="element.validators?.required" class="text-danger"> *</small>
                                        </label>

                                        <!-- Text input -->
                                        <div v-if="element.type === 'text'">
                                          <input type="text" :name="element.name + '-' + index" :id="element.name" 
                                          :class="{
                                            [element.class]: true,
                                            'input-valid': formData[index][element.name],
                                            'input-invalid': !formData[index][element.name]
                                          }"
                                          :placeholder="element.placeholder" v-model="formData[index][element.name]"/>
                                          <small v-if="validationErrors[index]?.[element.name]" class="text-danger d-block mt-1">{{ validationErrors[index][element.name] }}</small>
                                        </div>

                                        <!-- Number input -->
                                        <div v-if="element.type === 'number'">
                                          <input type="number" :name="element.name + '-' + index" :id="element.name" 
                                          :class="{
                                            [element.class]: true,
                                            'input-valid': formData[index][element.name],
                                            'input-invalid': !formData[index][element.name]
                                          }"
                                          :placeholder="element.placeholder || 'Enter number'" :pattern="element.validators?.regex" inputmode="numeric" min="0"  v-model="formData[index][element.name]"/>
                                          <small v-if="validationErrors[index]?.[element.name]" class="text-danger d-block mt-1">{{ validationErrors[index][element.name] }}</small>
                                        </div>

                                        <!-- Email input -->
                                        <div v-if="element.type === 'email'">
                                          <input type="email" :name="element.name + '-' + index" :id="element.name" 
                                          :class="{
                                            [element.class]: true,
                                            'input-valid': formData[index][element.name],
                                            'input-invalid': !formData[index][element.name]
                                          }"
                                          :placeholder="element.placeholder" v-model="formData[index][element.name]" />
                                          <small v-if="validationErrors[index]?.[element.name]" class="text-danger d-block mt-1">{{ validationErrors[index][element.name] }}</small>
                                        </div>

                                        <!-- Date input -->
                                        <!-- <div v-if="element.type === 'date'">
                                          <input type="date" :name="element.name + '-' + index" :id="element.name" :class="element.class" :placeholder="element.placeholder" :min="element.is_expiration ? getExpirationMinDate(element) : null"  @change="handleConditional(element.name, $event.target.value)" v-model="formData[index][element.name]"/>
                                          <small v-if="validationErrors[index]?.[element.name]" class="text-danger d-block mt-1">{{ validationErrors[index][element.name] }}</small>
                                        </div> -->

                                        <div v-if="element.type === 'date'">
                                          <input
                                            type="date"
                                            :name="element.name + '-' + index"
                                            :id="element.name"
                                            :class="{
                                              [element.class]: true,
                                              'input-valid': formData[index][element.name],
                                              'input-invalid': !formData[index][element.name]
                                            }"
                                            :placeholder="element.placeholder"
                                            :min="element.is_expiration ? getExpirationMinDate(element) : null"
                                            v-model="formData[index][element.name]"
                                            @change="handleConditional(element.name, $event.target.value)"
                                          />

                                          <small v-if="validationErrors[index]?.[element.name]" class="text-danger d-block mt-1">
                                            {{ validationErrors[index][element.name] }}
                                          </small>
                                        </div>


                                                            
                                        <!-- Radio input -->
                                        <div v-if="element.type === 'radio'">
                                          <p class="form-label mb-1">{{ element.label }}
                                            <small v-if="element.validators?.required" class="text-danger">*</small>
                                          </p>
                                          <p class="text-muted"><small>{{ element.placeholder }}</small></p>

                                          <div
                                            :class="[
                                              'radio-group p-2',
                                              formData[index][element.name] ? 'input-valid' : 'input-invalid'
                                            ]"
                                          >


                                            <div class="form-check" v-for="(option, idx) in element.values" :key="idx">
                                              <input class="form-check-input" type="radio" :id="element.name + '-' + option.value"
                                                :name="element.name + '-' + index" :value="option.value" :class="element.class"
                                                @change="handleConditional(element.name, option.value)"
                                                :checked="formData[index][element.name] === option.value"
                                                />
                                              <label class="form-check-label" :for="element.name + '-' + option.value">{{ option.label }}</label>
                                            </div>
                                            <small v-if="validationErrors[index]?.[element.name]" class="text-danger d-block mt-1">{{ validationErrors[index][element.name] }}</small>
                                          </div>
                                        </div>

                                        <!-- File input -->
                                        <!-- <div v-if="element.type === 'file' &&
                                          (!element.has_conditional || 
                                            conditionalValues[element.has_conditional.has_conditional_name] === element.has_conditional.has_conditional_value)">
                                          <div class="upload-box p-2">
                                            <p>{{ element.placeholder || 'Please attach a file' }}</p>
                                            <label :for="element.name + '-' + index" class="custom-file-upload">{{ element.browseText || 'Browse files' }}</label>
                                            <input
                                              type="file"
                                              :name="element.name + '-' + index"
                                              :id="element.name + '-' + index"
                                              style="display: none;"
                                              :class="element.class"
                                              :multiple="element.multiple"
                                              :accept="element.validators?.accept ? element.validators.accept.split(',').map(ext => '.' + ext).join(',') : null"
                                              @change="handleFileUpload($event, element.name, index)"
                                            />
                                            <small class="text-muted d-block mt-2" v-if="selectedFiles[index]?.[element.name]">
                                              Selected: {{ selectedFiles[index][element.name] }}
                                            </small>
                                          </div>
                                          <small v-if="validationErrors[index]?.[element.name]" class="text-danger d-block mt-1">{{ validationErrors[index][element.name] }}</small>
                                        </div> -->

                                        <div v-if="element.type === 'file' &&
                                          (!element.has_conditional ||
                                            conditionalValues[element.has_conditional.has_conditional_name] ===
                                            element.has_conditional.has_conditional_value)"
                                        >
                                          <div class="upload-box p-2"
                                          :class="[
                                            selectedFiles[index]?.[element.name] || formData[index][element.name]
                                              ? 'input-valid'
                                              : 'input-invalid'
                                          ]">
                                            <p>{{ element.placeholder || 'Please attach a file' }}</p>
                                            <label :for="element.name + '-' + index" class="custom-file-upload">
                                              {{ element.browseText || 'Browse files' }}
                                            </label>
                                            <input
                                              type="file"
                                              :name="element.name + '-' + index"
                                              :id="element.name + '-' + index"
                                              style="display: none;"
                                              :class="element.class"
                                              :multiple="element.multiple"
                                              :accept="element.validators?.accept
                                                ? element.validators.accept.split(',').map(ext => '.' + ext).join(',')
                                                : null"
                                              @change="handleFileUpload($event, element.name, index)"
                                            />
                                            <small class="text-muted d-block mt-2" v-if="selectedFiles[index]?.[element.name]">
                                              Selected: {{ selectedFiles[index][element.name] }}
                                            </small>
                                            <small class="text-muted d-block mt-2" v-else-if="formData[index][element.name]">
                                              Previously uploaded: {{
                                                formData[index][element.name].split('/').pop()
                                              }}
                                            </small>

                                          </div>
                                          

                                          <small v-if="validationErrors[index]?.[element.name]" class="text-danger d-block mt-1">
                                            {{ validationErrors[index][element.name] }}
                                          </small>
                                        </div>


                                        <!-- Select input -->
                                        <div v-if="element.type === 'select'">
                                          <select :name="element.name + '-' + index" :id="element.name" 
                                           :class="{
                                            [element.class]: true,
                                            'input-valid': formData[index][element.name],
                                            'input-invalid': !formData[index][element.name]
                                           }"
                                           :multiple="element.multiple" @change="handleConditional(element.name, $event.target.value)" v-model="formData[index][element.name]">
                                            <option disabled value="">{{ element.placeholder || 'Select an option' }}</option>
                                            <option v-for="(option, idx) in element.values" :key="idx" :value="option.value">
                                              {{ option.label }}
                                            </option>
                                          </select>
                                          <small v-if="validationErrors[index]?.[element.name]" class="text-danger d-block mt-1">{{ validationErrors[index][element.name] }}</small>
                                        </div>

                                      </template>
                                    </div>


                                    <!-- NEXT button -->
                                    <div  v-if="currentFormIndex < forms.length - 1">
                                      <div class="d-flex flex-column align-items-end">
                                        <button type="button" class="btn next-btn w-30" @click="goToNextForm">
                                          Continue to Next Application >>
                                        </button>
                                      </div>
                                      <small class="mb-2 text-end" style="color: gray;">
                                        Please complete the remaining applications and ensure all required fields are filled out.
                                      </small>
                                    </div>
                                    


                                    <!-- PREVIOUS button -->
                                    <div class="d-flex justify-content-end" v-if="currentFormIndex > 0">
                                      <button type="button" class="btn prev-btn w-30" @click="goToPreviousForm">&laquo;&laquo; Previous Application</button>
                                    </div>



                                  </div>
                                </div>
                              </div>
                            </div>
                          </div>
                        </div>

                        <div class="col-md-12 my-5 d-flex align-items-center justify-content-center">
                          <input type="checkbox" id="whatsapp-updates" class="custom-checkbox me-2">
                          <label for="whatsapp-updates" class="update_msg">I declare that all the information entered in the form is true and correct to the best of my knowledge.</label>
                        </div>
                        <small id="whatsapp-error" class="text-danger" style="display:none;">
                          Please confirm that all information entered is correct.
                        </small>
                        <div class="text-center my-5">
                          <button type="submit" class="btn continue-btn w-50" :disabled="isSubmitting" id="submitBtn">
                            <span v-if="isSubmitting"><i class="fa fa-spinner fa-spin me-2"></i>Updating...</span>
                            <span v-else>Update</span>
                          </button>
                        </div>
                    </form>
                  </div>
                  <div class="col-12 col-md-4 mt-3 mt-md-0">
                      <Instructions />
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import { PassPortCheck, AddApplicantDetails, GetVisaCategories, UpdateApplicantDetails } from '@/api/Post/form';
import Swal from 'sweetalert2';
import router from '@/router';
import 'animate.css';
import Instructions from '@/components/Appointment/Sections/History/SideBar/Instructions.vue';
export default {
  name: 'editSingleBookingForm',
  props: {
    applicantId: String,
    booking: {
        type: Object,
        required: true
    }
  },
  components: {
    Instructions
  },
  data() {
    return {
      forms: [],
      currentlyOpenForm: 'app1',
      savedFormData: null,
      selectedFiles: {},
      validationErrors: {},
      renderedErrorFlags: {},
      formData: {},
      conditionalValues: {},
      openFormIds: [],
      isSubmitting: false,
      paymentData: null,
      form__Id : null,
    };
  },
  mounted() {
    const count = parseInt(this.$route.query.applicants || 1);
    this.forms = Array.from({ length: count }, (_, i) => ({ id: 'app' + (i + 1) }));

    const saved = localStorage.getItem('form_response');
    this.savedFormData = saved ? JSON.parse(saved) : null;
    ///console.log('this.savedFormData :', JSON.stringify(this.savedFormData));
    this.paymentData = this.booking;

    // Open the first form
    this.forms = Array.from({ length: count }, (_, i) => ({
      id: 'app' + (i + 1),
      elements: JSON.parse(JSON.stringify(this.savedFormData?.data?.elements || []))
    }));

    const storedApplicants = localStorage.getItem('applicant_data');
    if (storedApplicants) {
      const parsed = JSON.parse(storedApplicants);

      const applicantList = Array.isArray(parsed.data)
        ? parsed.data
        : [parsed.data];
      ///console.log('applicantList : ', applicantList[0]?.form_id);
      this.form__Id = applicantList[0]?.form_id;
      this.formData = applicantList.map(app => {
        const fields = app.form_elements || [];
        const obj = {};

        fields.forEach(field => {
          let value = field.field_value;

          if (field.field_type === 'date' && /^\d{2}-\d{2}-\d{4}$/.test(value)) {
            const [day, month, year] = value.split('-');
            value = `${year}-${month}-${day}`;
          }

          obj[field.field_name] = value;
        });

        return obj;
      });
    } else {
      this.formData = this.forms.map(() => ({}));
    }




    this.openFormIds = [this.forms[0].id];

    this.loadDynamicSelectOptions();
    this.initializeRadioConditionals();
    this.initializeConditionalValues();
  },
  computed: {
    currentFormIndex() {
      return this.forms.findIndex(f => f.id === this.currentlyOpenForm);
    }
  },


  methods: {
    toggleForm(formId) {
      this.currentlyOpenForm = this.currentlyOpenForm === formId ? null : formId;
      if (this.currentlyOpenForm) {
        const saved = localStorage.getItem('bookingFormData');
        this.savedFormData = saved ? JSON.parse(saved) : null;
      }
    },

    goToNextForm() {
      const currentIndex = this.currentFormIndex;
      if (currentIndex < this.forms.length - 1) {
        this.currentlyOpenForm = this.forms[currentIndex + 1].id;
      }
    },
    goToPreviousForm() {
      const currentIndex = this.currentFormIndex;
      if (currentIndex > 0) {
        this.currentlyOpenForm = this.forms[currentIndex - 1].id;
      }
    },

    handleConditional(fieldName, value) {
      ///console.log('fieldName:', fieldName, '- value:', value);
      this.conditionalValues[fieldName] = value;

      // if (!this.formData[formIndex]) this.formData[formIndex] = {};
      // this.formData[formIndex][fieldName] = value;
    }, 


    handleFileUpload(event, fieldName, formIndex) {
      const files = event.target.files;
      if (!files.length) return;

      const file = files[0];

      // Init selectedFiles and formData arrays
      if (!this.selectedFiles[formIndex]) this.selectedFiles[formIndex] = {};
      if (!this.formData[formIndex]) this.formData[formIndex] = {};

      // Store filename for UI
      this.selectedFiles[formIndex][fieldName] = file.name;

      const reader = new FileReader();

      reader.onload = async () => {
        const base64String = reader.result; // keep full "data:image/..." prefix
        this.formData[formIndex][fieldName] = base64String; // 👈 This is critical

        // Special case for passport validation
        if (fieldName === 'attachpassport') {
          try {
            Swal.fire({
              title: 'Processing...',
              text: 'Please wait while we read your passport details.',
              allowOutsideClick: false,
              allowEscapeKey: false,
              didOpen: () => {
                Swal.showLoading();
              }
            });

            const result = await PassPortCheck(base64String.split(',')[1]); // Send only base64 body

            Swal.close();
            
            const passportData = result.data?.data?.result?.extraction_output;
            if (!result.data.success || !passportData || !passportData.id_number) {
              Swal.fire({
                title: 'Attention!',
                text: 'We are unable to read the details from your passport. Please ensure both sides are included.',
                confirmButtonText: 'Close',
                customClass: {
                  popup: 'custom-error-alert',
                  confirmButton: 'white-confirm-button'
                },
                showClass: {
                  popup: 'animate__animated animate__shakeX'
                },
                hideClass: {
                  popup: 'animate__animated animate__fadeOutUp'
                }
              });
            } else {
              //console.log(" Passport details extracted:", passportData);
              // Debug: log all input names
              //document.querySelectorAll("input, select, textarea").forEach(el => {
                //console.log("Available input:", el.name);
              //});

              // Map passport fields into dynamic form
              const mapping = {
                id_number: "passportnumber",               
                first_name: "givenname",                 
                surname: "surname",  
                last_name: "surname",                      
                date_of_birth: "dateofbirth",              
                date_of_expiry: "passportexpirydate",      
                nationality: "country",                    
                gender: "gender",                          
                place_of_birth: "placeofbirth",            
                state: "state",                            
                district: "district",                      
                residential_address: "residentialaddressasshowninpassport" ,
                address: "residentialaddressasshowninpassport",
                fathers_name: "fathersname",
                mothers_name: "mothersname",
                place_of_issue: "placeofissue",
                file_number: "filenumber",
                date_of_issue: "passportissuedate",
                pincode: "pincode"
              };

              // loop over mapping and push values into formData
              Object.entries(mapping).forEach(([passportKey, formField]) => {
                let value = passportData[passportKey];

                // Special handling for gender
                if (passportKey === "gender" && value) {
                  const genderVal = value.toString().toLowerCase();
                  if (["m", "male"].includes(genderVal)) value = "Male";
                  else if (["f", "female"].includes(genderVal)) value = "Female";
                  else value = "Unknown";
                }

                // Special handling for residential address
                if (formField === "residentialaddressasshowninpassport") {
                  value = passportData.address || "";
                }

                if (value) {
                  if (!this.formData[formIndex]) this.formData[formIndex] = {};
                  this.formData[formIndex][formField] = value;

                  const inputEl = document.querySelector(`[name="${formField}-${formIndex}"]`);
                  if (inputEl) {
                    if (inputEl.type === "radio" && passportKey === "gender") {
                      const radios = document.querySelectorAll(`[name="${formField}-${formIndex}"]`);
                      radios.forEach(radio => {
                        radio.checked = (radio.value.toLowerCase() === value.toLowerCase());
                      });
                    } else {
                      inputEl.value = value;
                    }
                  } else {
                    console.warn(` Input not found for: ${formField}`);
                  }
                }

              });

            }
          } catch (error) {
            Swal.fire({
              title: 'Error',
              text: error.response?.data?.message || 'Upload failed!',
              icon: 'error',
              confirmButtonText: 'OK'
            });
          }
        }
      };

      reader.readAsDataURL(file);
    },





    async handleSubmit(event) {
        event.preventDefault();
        this.isSubmitting = true;
        const valid = this.validateCurrentForm();

        if (!valid) {
          ///console.log("Validation failed", this.validationErrors);
          this.isSubmitting = false;
          return;
        }

        // Build applicants array of objects
        // const appContainer = this.$el.querySelector(".application-form"); 
        // const appObj = {};

        // for (const element of this.savedFormData.data.elements) {
        //   const name = element.name;
        //   const inputType = element.type;
        //   const inputs = appContainer.querySelectorAll(`[name="${name}-0"]`); 

        //   const isConditional = element.is_conditional;
        //   let shouldRender = true;

        //   if (isConditional && element.conditional_details) {
        //     const { conditional_name, conditional_value } = element.conditional_details;
        //     shouldRender = this.conditionalValues?.[conditional_name] === conditional_value;
        //   }

        //   if (!shouldRender) {
        //     appObj[name] = '';
        //     continue;
        //   }


        //   if (!inputs.length) continue;

        //   if (inputType === 'file') {
        //     if (this.formData?.[0]?.[name]) {
        //       const base64String = this.formData[0][name];
        //       appObj[name] = base64String;
        //     } else {
        //       appObj[name] = '';
        //     }
        //   } else if (inputType === 'radio') {
        //     const checked = Array.from(inputs).find(input => input.checked);
        //     appObj[name] = checked ? checked.value : '';
        //   } else if (inputType === 'select' && inputs[0].multiple) {
        //     const selectedValues = Array.from(inputs[0].selectedOptions).map(o => o.value);
        //     appObj[name] = selectedValues;
        //   } else {
        //     let val = inputs[0].value.trim();
        //     if (inputType === 'date' && val) {
        //       const dateObj = new Date(val);
        //       const day = String(dateObj.getDate()).padStart(2, '0');
        //       const month = String(dateObj.getMonth() + 1).padStart(2, '0');
        //       const year = dateObj.getFullYear();
        //       val = `${day}-${month}-${year}`;
        //     }
        //     appObj[name] = val;
        //   }
        // }

        const formIndex = this.forms.findIndex(f => f.id === this.currentlyOpenForm);
        const appContainer = this.$el.querySelectorAll(".application-form")[formIndex];
        const appObj = {};
        const applicants = [];

        for (let i = 0; i < this.forms.length; i++) {
          const appObj = {};
          const appContainer = this.$el.querySelectorAll(".application-form")[i];
          if (!appContainer) continue;

          for (const element of this.savedFormData.data.elements) {
            const name = element.name;
            const inputType = element.type;

            const inputs = appContainer.querySelectorAll(`[name="${name}-${i}"]`);
            if (!inputs.length) continue;

            if (inputType === 'file') {
              if (this.formData?.[i]?.[name]) {
                const base64String = this.formData[i][name];
                appObj[name] = base64String;
              } else {
                appObj[name] = '';
              }
            } else if (inputType === 'radio') {
              const checked = Array.from(inputs).find(input => input.checked);
              appObj[name] = checked ? checked.value : '';
            } else if (inputType === 'select' && inputs[0].multiple) {
              const selectedValues = Array.from(inputs[0].selectedOptions).map(o => o.value);
              appObj[name] = selectedValues;
            } else {
              let val = inputs[0].value.trim();
              if (inputType === 'date' && val) {
                const dateObj = new Date(val);
                const day = String(dateObj.getDate()).padStart(2, '0');
                const month = String(dateObj.getMonth() + 1).padStart(2, '0');
                const year = dateObj.getFullYear();
                val = `${day}-${month}-${year}`;
              }
              appObj[name] = val;
            }
          }

          appObj['form_id'] = this.form__Id;
          applicants.push(appObj);
        }


        // console.log('this.storedApplicants : ', this.storedApplicants);
       
        //console.log('this.appObj : ', JSON.stringify(applicants, null, 2));
        //console.log('Final formData:', JSON.stringify(this.formData, null, 2));

        // Call your API, pass the applicants array and other data:
        const applicantId = localStorage.getItem('applicant_id');
        try {
          await UpdateApplicantDetails(applicantId,applicants[0]);


          let timerInterval;
          
          Swal.fire({
            title: "❤️ Application Updated!",
            html: `
              Your application has been updated successfully!<br>
              <strong>Booking Number:</strong> ${this.paymentData?.booking_no}
            `,
            allowOutsideClick: false,
            allowEscapeKey: false,
            allowEnterKey: false,
            showCancelButton: true,
            showConfirmButton: false, 
            cancelButtonText: '<i class="fas fa-home"></i> Home',
            customClass: {
              popup: 'custom-error-alert',
              cancelButton: 'red-home-button'
            },
            showClass: {
              popup: 'animate__animated animate__fadeInDown',
            },
            hideClass: {
              popup: 'animate__animated animate__fadeOutUp',
            }
          }).then((result) => {
            this.isSubmitting = false;

            if (result.dismiss === Swal.DismissReason.cancel) {
              ///this.$router.push({ name: 'landingPage' });
              window.location.href = '/track/track-view-details';
            }
          });




        } catch (error) {
          this.isSubmitting = false;
          Swal.fire({
            icon: 'error',
            title: 'Submission Failed',
            text: 'There was a problem submitting your application. Please try again.',
          });
        }
    },

    validateCurrentForm() {
      this.validationErrors = {};
      let isValid = true;
      let firstInvalidInput = null;

      if (!this.savedFormData || !this.savedFormData.data?.elements) return false;

      ////console.log('Final formData:', JSON.stringify(this.formData, null, 2));return false;

      this.forms.forEach((form, index) => {
        const appContainer = this.$el.querySelectorAll(".application-form")[index];
        if (!appContainer) return;

        const currentErrors = {};
        const validatedFields = new Set();

        this.savedFormData.data.elements.forEach(element => {
          const name = element.name;
          const uniqueKey = `${name}-${index}`;
          if (validatedFields.has(uniqueKey)) return;
          validatedFields.add(uniqueKey);

          const validators = element.validators || {};
          const inputType = element.type;
          // IMPORTANT: query input by name with index suffix to match template input name!
          const inputs = appContainer.querySelectorAll(`[name="${name}-${index}"]`);
          if (!inputs.length) return;
          ///console.log('hai::');
          let value = '';
          let isChecked = false;

          if (inputType === 'radio') {
            const checked = Array.from(inputs).find(input => input.checked);
            isChecked = !!checked;
            value = checked ? checked.value : '';
          } else if (inputType === 'file') {
            const input = inputs[0];
            const files = input.files;

            if (validators.required && (!files || files.length === 0)) {
              // currentErrors[name] = `${element.label} is required.`;
              // isValid = false;
              // return;
              const previousValue = this.formData?.[index]?.[name];
              if (!previousValue) {
                currentErrors[name] = `${element.label} is required.`;
                isValid = false;
                if (!firstInvalidInput) firstInvalidInput = input;
                return;
              }
            }

            if (files && files.length > 0) {
              const file = files[0];
              const allowedTypes = (validators.filetype || '').split(',').map(t => t.trim().toLowerCase());
              const ext = file.name.split('.').pop().toLowerCase();
              if (validators.filetype && !allowedTypes.includes(ext)) {
                currentErrors[name] = `${element.label} format must be ${validators.filetype}.`;
                isValid = false;
                if (!firstInvalidInput) firstInvalidInput = input;
              }

              const fileSizeMB = file.size / (1024 * 1024);
              if (validators.maxsize && fileSizeMB > parseFloat(validators.maxsize)) {
                currentErrors[name] = `${element.label} exceeds ${validators.maxsize}MB.`;
                isValid = false;
                if (!firstInvalidInput) firstInvalidInput = input;
              }

              if (validators.minsize && fileSizeMB < parseFloat(validators.minsize)) {
                currentErrors[name] = `${element.label} must be more than ${validators.minsize}MB.`;
                isValid = false;
                if (!firstInvalidInput) firstInvalidInput = input;
              }
            }

            return;
          } else {
            value = inputs[0].value.trim();
          }

          if (validators.required && (!value || (inputType === 'radio' && !isChecked))) {
            currentErrors[name] = `${element.label} is required.`;
            isValid = false;
            if (!firstInvalidInput) firstInvalidInput = inputs[0];
          }

          if (inputType === 'email' && value) {
            const emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
            if (!emailRegex.test(value)) {
              currentErrors[name] = `${element.label} must be a valid email address.`;
              isValid = false;
              if (!firstInvalidInput) firstInvalidInput = inputs[0];
            }
          } else if (validators.regex && value) {
            const regex = new RegExp(validators.regex);
            if (!regex.test(value)) {
              currentErrors[name] = `${element.label} format is invalid.`;
              isValid = false;
              if (!firstInvalidInput) firstInvalidInput = inputs[0];
            }
          }

          if (inputType === 'date' && element.is_expiration && value) {
            const expirationNo = parseInt(element.expiration_details?.expiration_no || 0);
            const expirationType = element.expiration_details?.expiration_type;
            const expiryDate = new Date(value);
            const futureDate = new Date();

            if (expirationType === 'month') {
              futureDate.setMonth(futureDate.getMonth() + expirationNo);
            }

            if (expiryDate <= futureDate) {
              currentErrors[name] = `${element.label} must be more than ${expirationNo} ${expirationType}(s) from today.`;
              isValid = false;
              if (!firstInvalidInput) firstInvalidInput = inputs[0];
            }
          }
        });

        // if (Object.keys(currentErrors).length > 0) {
        //   this.validationErrors[index] = currentErrors;
        //   const formId = this.forms[index].id;
        //   ///console.log('formId: ', formId);
        //   if (!this.currentlyOpenForm) {
        //     this.currentlyOpenForm = formId;
        //   }
        // } else {
        //   delete this.validationErrors[index]; 
        // }

        if (Object.keys(currentErrors).length > 0) {
          //console.log('hi');
          this.validationErrors[index] = currentErrors;

          const formId = this.forms[index].id;

          // Always store the first invalid input only once
          if (!firstInvalidInput) {
            firstInvalidInput = [...appContainer.querySelectorAll(`[name]`)].find(input => {
              const name = input.name.split('-')[0];
              const match = currentErrors.hasOwnProperty(name);
              if (match) {
                //console.log('Found first invalid input name match:', name);
              }
              return match;
            });

            this.currentlyOpenForm = formId;
          }

          // Move focus logic outside the above `if`
          this.$nextTick(() => {
            setTimeout(() => {
              try {
                if (!firstInvalidInput) {
                  console.warn('No invalid input found!');
                  return;
                }

                const inputType = firstInvalidInput.type;
                const inputId = firstInvalidInput.id;
                const isHidden = !firstInvalidInput.offsetParent;

                if (inputType === 'file' && isHidden) {
                  const label = document.querySelector(`label[for="${inputId}"]`);
                  if (label) {
                    //console.log('Scrolling to label:', label);
                    label.scrollIntoView({ behavior: 'smooth', block: 'center' });
                    label.classList.add('highlight-label');
                    setTimeout(() => label.classList.remove('highlight-label'), 2000);
                  } else {
                    console.warn('No label found for file input');
                  }
                } else {
                 // console.log('Focusing normal input');
                  firstInvalidInput.focus({ preventScroll: false });
                  firstInvalidInput.scrollIntoView({ behavior: 'smooth', block: 'center' });
                }
                this.currentlyOpenForm = formId;
              } catch (e) {
                console.error("Focus/scroll failed:", e);
              }
            }, 100);
          });
        } else {
          delete this.validationErrors[index];
        }



      });

      const declarationCheckbox = document.getElementById("whatsapp-updates");
      const errorMessage = document.getElementById("whatsapp-error");
      if (!declarationCheckbox || !declarationCheckbox.checked) {
        if (errorMessage) errorMessage.style.display = "block";
        isValid = false;
      } else {
        if (errorMessage) errorMessage.style.display = "none";
      }

      return isValid;
    },



    
    shouldRenderError(fieldName, index) {
      if (this.renderedErrorFlags[fieldName]) return false;
      this.renderedErrorFlags[fieldName] = true;
      return true;
    },

    getExpirationMinDate(element) {
      const today = new Date();
      const minDate = new Date(today);

      const { expiration_type, expiration_no } = element.expiration_details || {};

      if (expiration_type === 'month') {
        minDate.setMonth(minDate.getMonth() + expiration_no);
      } else if (expiration_type === 'day') {
        minDate.setDate(minDate.getDate() + expiration_no);
      } else if (expiration_type === 'year') {
        minDate.setFullYear(minDate.getFullYear() + expiration_no);
      }

      minDate.setDate(minDate.getDate() + 1);

      return minDate.toISOString().split('T')[0]; 
    },

    loadDynamicSelectOptions() {
      if (!Array.isArray(this.forms)) {
        //console.warn('this.forms is not an array:', this.forms);
        return;
      }

      this.forms.forEach((form, formIndex) => {
        if (!Array.isArray(form.elements)) {
          //console.warn(`form.elements is not an array at formIndex ${formIndex}:`, form.elements);
          return;
        }

        form.elements.forEach((element, index) => {
          if (element.name === 'visacategory' && element.type === 'select') {
            GetVisaCategories()
              .then((response) => {
                if (response.data && response.data.success) {
                 this.savedFormData.data.elements[index].values = response.data.data;
                }
              })
              .catch((error) => {
                console.error("Error fetching visa categories:", error);
              });
          }
        });
      });
    },


    initializeRadioConditionals() {
      if (!this.formData || !Array.isArray(this.formData)) return;

      this.savedFormData.data.elements.forEach((element) => {
        const type = element.type;
        const name = element.name;

        if (['radio', 'select', 'date'].includes(type)) {
          const value = this.formData[0]?.[name]; // adjust index if needed
          if (value) {
            this.conditionalValues[name] = value;
          }
        }
      });
    },

    initializeConditionalValues() {
      this.forms.forEach((form, index) => {
        const elements = form.elements || [];

        elements.forEach((element) => {
          const name = element.name;
          const type = element.type;
          const value = this.formData[index]?.[name];

          if (value && ['radio', 'select', 'date'].includes(type)) {
            this.conditionalValues[name] = value;
          }
        });
      });
    },


  },
}

</script>